function init_tag_input(sender) {
    const $ = jQuery.noConflict();
    const tagsWrapper = $(sender);
    const addNewWrapper = tagsWrapper.find('.add-new-wrapper');
    let fetchDataAjax;

    tagsWrapper.parents('form').attr('novalidate', 1);

    const type = tagsWrapper.attr('data-type');

    const fn = type + 'Selector();';
    eval('$(\'[data-' + type + '-selector]\').' + fn);

    init_max_width_detection();

    init_current_data();

    init_add_button();

    init_remove_button();

    init_count_button();

    reset_if_cloned();

    function init_max_width_detection() {
        const onResize = () => {
            // detect the width of the tagsWrapper, set that as a tag-max-width css variable
            const width = tagsWrapper.width();
            tagsWrapper[0].style.setProperty('--tag-max-width', width - 10 + 'px');
        }
        $(window).unbind('resize', onResize).resize(onResize);
        onResize();
    }

    function init_current_data() {
        const ids = tagsWrapper.getTags();

        if (ids.length > 0) {
            if (fetchDataAjax) {
                fetchDataAjax.abort();
            }
            $(tagsWrapper).isLoading();
            fetchDataAjax = $.ajax({
                url: '/ajax/specialSelectorSearch',
                data: {
                    type,
                    filters: {
                        id: ids
                    }
                }
            }).then(function(data) {
                const isIndexedArray = data.length > 0 && data[0] !== undefined;

                for(let i in data) {
                    let id;
                    if (isIndexedArray) {
                        id = data[i].id;
                    } else {
                        id = i;
                    }
                    const tagWrapper = tagsWrapper.find(':input[value="' + id + '"][type="hidden"]').parents('.tag-wrapper');

                    const object = get_name_from_tag_object(tagsWrapper, data[i]);

                    tagWrapper.find('.tag').html(object);
                    const count = parseInt(tagWrapper.find('.count-input-wrapper input').val());
                    set_tag_count(tagWrapper, count);
                }
                filter_selected_tag_ids(tagsWrapper);
            }, function(err) {
                console.error('Er ging iets mis bij het ophalen van de gegevens.');
            }).always(function() {
                $(tagsWrapper).doneLoading();
            })
        }
    }

    function init_add_button() {
        addNewWrapper.find('.button.primary').unbind('click').click(function() {
            if (tagsWrapper.is('[data-easy-add]')) {
                addNewWrapper.find('select').trigger('addObject');
            } else {
                const input = tagsWrapper.find('.special-selector-search-bar');
                input.focus();
            }
           return false;
        });
        if (tagsWrapper.is('[data-easy-add]')) {
            addNewWrapper.find('input').keydown(function(e) {
                if (e.key === 'Enter') {
                    addNewWrapper.find('.button.primary').trigger('click');
                    // const searchInput = $(this);
                    //
                    // searchInput.blur();
                    //
                    // setTimeout(() => {
                    //     searchInput.val('');
                    //     searchInput.trigger('focus');
                    // }, 100);
                }
            })
        }

        addNewWrapper.find('select').change(function() {
            const select = $(this);
            const id = select.val();
            const name = select.find('option[value=' + id + ']').text();
            if (id > 0 && !isNaN(id)) {
                set_tag_item(tagsWrapper, id, name);

                tagsWrapper.trigger('changeTags', [tagsWrapper.getTags(),{id, name}]);
            }
        });
    }

     function init_remove_button() {
         tagsWrapper.find('.remove-from-selection').click(function() {
             const tagWrapper = $(this).parents('.tag-wrapper');
             const name = tagWrapper.find('.tag').text();
             const id = tagWrapper.find('input[type="hidden"]').val();
             tagWrapper.addClass('remove');

             setTimeout(function() {
                 tagWrapper.remove();
                 filter_selected_tag_ids(tagsWrapper);

                 tagsWrapper.trigger('changeTags', [tagsWrapper.getTags(), undefined, {id, name}]);
             }, 250);
             return false;
        });
    }

    function init_count_button() {
        if(!tagsWrapper.is('[data-multiple="true"]')) {
            return;
        }
        tagsWrapper.find('.count-wrapper').click(function() {
            const tagWrapper = $(this).parents('.tag-wrapper');
            const inputWrapper = tagWrapper.find('.count-input-wrapper');
            const input = inputWrapper.find('input');

            input.css({width: $(this).outerWidth() + 20});
            inputWrapper.addClass('show');
            input.focus();
            return false;
        });

        tagsWrapper.find('.count-input-wrapper input').blur(function() {
            const tagWrapper = $(this).parents('.tag-wrapper');
            const inputWrapper = tagWrapper.find('.count-input-wrapper');
            inputWrapper.removeClass('show');

            const value = parseInt($(this).val());

            if (value < 1) {
                tagWrapper.find('.remove-from-selection').click();
            } else {
                set_tag_count(tagWrapper, value);
            }
        });
    }
    function reset_if_cloned() {
        tagsWrapper.parents('.repeat-item').bind('on-clone', function() {
            const tagsWrapper = $(this).find('.tags-wrapper');
            tagsWrapper.find('input.automated').remove();
            tagsWrapper.find('.tag-wrapper:not([data-dummy])').remove();
        });
    }
}
function get_name_from_tag_object(tagsWrapper, object) {
    if (typeof object === 'object') {
        if (tagsWrapper.is('[data-name]')) {
            return object[tagsWrapper.attr('data-name')];
        }
        if (object.name) {
            return object.name;
        }
        if (object.description) {
            return object.description;
        }
        return object.id;
    }
    return object;
}
function set_tag_item(tagsWrapper, id, name, count = 1) {
    const addNewWrapper = tagsWrapper.find('.add-new-wrapper');
    let input = tagsWrapper.find('.tag-wrapper input[type="hidden"][value="' + id + '"]');
    let tagWrapper;
    if (input.length === 0) {
        tagWrapper = tagsWrapper.find('.tag-wrapper[data-dummy]').clone(true, true);
        tagWrapper.removeAttr('data-dummy');
        input = tagWrapper.find('input[type="hidden"]');
        input.removeAttr('disabled');
        input.attr('value', id);
        tagWrapper.find('.tag').html(name);


        addNewWrapper.before(tagWrapper);
    } else {
        tagWrapper = input.parents('.tag-wrapper');
        count = parseInt(tagWrapper.find('.count-wrapper').text()) + count;
    }
    set_tag_count(tagWrapper, count);

    filter_selected_tag_ids(tagsWrapper);
}

function filter_selected_tag_ids(tagsWrapper) {
    const $ = jQuery.noConflict();
    const addNewWrapper = tagsWrapper.find('.add-new-wrapper');

    if (tagsWrapper.is('[data-multiple="true"]') || addNewWrapper.length === 0) {
        return;
    }
    const select = addNewWrapper.find('select');
    let filterKey = select.attr('data-filter-key');
    if (filterKey === undefined) {
        filterKey = get_unique_id('data-filter-key');
        select.attr('data-filter-key', filterKey);
    }

    addNewWrapper.find('input[type="hidden"][name][value]:not(.automated):not([data-' + filterKey + '-filter])').attr('data-' + filterKey + '-filter', true);

    addNewWrapper.find('[data-' + filterKey + '-filter].automated').remove();

    tagsWrapper.find('.tag-wrapper:not([data-dummy])').each(function() {
        const id = parseInt($(this).find('input[type="hidden"][data-index="0"]').val());

        if (addNewWrapper.find('[data-' + filterKey + '-filter][value="' + id + '"]').length === 0) {
            const input = $('<input type="hidden" name="not_in[]" data-' + filterKey + '-filter class="automated" />');
            input.val(id);
            addNewWrapper.append(input);
        }
    });
}

function set_tag_count(tagWrapper, value = 1) {
    const countWrapper = tagWrapper.find('.count-wrapper');
    countWrapper.html(value);

    tagWrapper.find('input[type="hidden"][data-index]:not([data-index="0"])').remove();
    for (let i = 0; i < value; i ++) {
        let hiddenInput = tagWrapper.find('input[type="hidden"][data-index="' + i + '"]');
        if(hiddenInput.length === 0) {
            const lastInput = tagWrapper.find('input[type="hidden"][data-index]:last');
            hiddenInput = lastInput.clone();
            lastInput.after(hiddenInput);
            hiddenInput.attr('data-index', i);
        }
    }
    tagWrapper.find('.count-input-wrapper input').val(value);
}

(function ( $ ) {
    $.fn.setTags = function(data, remove = false) {
        this.each(function() {
            const elm = $(this);
            const isMulti = elm.is('[data-multiple="true"]');

            if (!isMulti) {
                // First remove all
                elm.find('.tag-wrapper:not([data-dummy])').each(function() {
                    const id = $(this).find('input[type="hidden"]').val();
                    elm.find(`input[type="hidden"][value="${id}"]`).remove();
                    $(this).remove();
                });
            }

            for(let i in data) {
                const object = data[i];
                const name = get_name_from_tag_object(elm, object);
                const id = object.id;
                const count = object.count ? parseInt(object.count) : 1;

                const itemInput = elm.find('.tag-wrapper:not(.remove) input[type="hidden"][value="' + id + '"]');
                const hasItem = function() {
                    return itemInput.length > 0;
                }();
                if (hasItem) {
                    if (!remove && !isMulti) {
                        continue;
                    }
                    const tagWrapper = itemInput.parents('.tag-wrapper');
                    const countInput = tagWrapper.find('input[type="number"]');
                    const currentCount = countInput.length > 0 ? parseInt(countInput.val()) : 1;

                    const newCount = remove ? currentCount - count : currentCount + count;
                    countInput.val(newCount).trigger('blur');
                } else {
                    if (remove) {
                        continue;
                    }
                    set_tag_item(elm, id, name, count);
                }
            }

            elm.trigger('changeTags');
        });
        return this;
    };
}( jQuery ));
(function ( $ ) {
    $.fn.getTags = function() {
        const tagsWrapper = $(this);

        const ids = [];
        tagsWrapper.find('.tag-wrapper:not(.remove) :input[name][value][type="hidden"]').each(function () {
            ids.push($(this).val());
        });
        return ids;
    };
}( jQuery ));
